import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { pricesLoader } from './prices-loader';

export const pricesRoutes: RouteObject = {
  loader: pricesLoader,
  children: [
    {
      path: '/admin/prices/products',
      lazy: lazyComponent(() => import('@pages/tenant/prices'), 'ProductPricesPage'),
    },
  ],
};
